export class QbPropertyDto {
  public readonly name: string;
  public readonly aliasName: string;
  public readonly label: string;
  public readonly type: string;
  public readonly tableName: string;
  public readonly selectable: boolean;
  public readonly whereable: boolean;
  public readonly enumName?: string;
  public readonly listName?: string;
  public readonly universeLabel?: string;

  constructor(
    name: string,
    aliasName: string,
    label: string,
    type: string,
    tableName: string,
    selectable: boolean,
    whereable: boolean,
    enumName?: string,
    listName?: string,
    universeLabel?: string,
  ) {
    this.name = name;
    this.aliasName = aliasName || undefined;
    this.label = label;
    this.type = type;
    this.tableName = tableName;
    this.selectable = selectable;
    this.whereable = whereable;
    this.enumName = enumName || undefined;
    this.listName = listName || undefined;
    this.universeLabel = universeLabel || undefined;
  }

  public static fromJson(json): QbPropertyDto {
    if (json) {
      return new QbPropertyDto(
        json.name,
        json.aliasName,
        json.label,
        json.type,
        json.tableName,
        json.selectable,
        json.whereable,
        json.enumName,
        json.listName,
        json.universeLabel,
      );
    }
  }
}
